import React from 'react';
import { InlineEditableText } from 'components/DesignSystems/InlineEditableText/InlineEditableText';
import type { GeoLocation } from './buildGeoLocationFromGeoJson';

export type LocationSummaryProps = {
  location: GeoLocation;
  readOnly?: boolean;
  onSaveName: (name: string) => void;
  onSaveAddress: (address: string) => void;
};

export const LocationSummary: React.FC<LocationSummaryProps> = ({
  location,
  readOnly = false,
  onSaveName,
  onSaveAddress,
}) => {
  return (
    <div className="tw:m-2 tw:text-sm">
      <InlineEditableText
        label="Name"
        value={location.name || ''}
        onSave={onSaveName}
        readOnly={readOnly}
      />
      <InlineEditableText
        label="Address"
        value={location.address || ''}
        onSave={onSaveAddress}
        readOnly={readOnly}
      />
      <div className="tw:flex tw:flex-wrap tw:items-center">
        <span className="tw:me-2 tw:text-muted-foreground">Lng/Lat:</span>
        <span
          className="tw:font-semibold"
          data-testid="location-summary-coords"
        >
          {(() => {
            const geometry = location?.centroid?.geometry;
            if (!geometry || geometry.type === 'GeometryCollection') {
              return '';
            }
            return JSON.stringify(geometry.coordinates);
          })()}
        </span>
      </div>
    </div>
  );
};
